import './Picture.scss';

const Picture = (props) => {
  const className = `
    atm-picture 
    ${props.className ? props.className : ''}
  `;

  return (
    <picture className={className}>
      <source srcSet={props.srcDesktop} media={'(min-width:394px)'}/>
      <img srcSet={props.srcMobile} alt={props.alt} />
    </picture>
  )
}

export default Picture;